var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrushIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brush_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.945,
    height: 28.945,
    viewBox: "0 0 28.945 28.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17077",
    "data-name": "Path 17077",
    d: "M0,0H28.945V28.945H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17078",
    "data-name": "Path 17078",
    d: "M8.03,18.679a1.21,1.21,0,0,1,1.206,1.206A2.419,2.419,0,0,1,6.824,22.3a3.407,3.407,0,0,1-.6-.06,4.76,4.76,0,0,0,.6-2.352A1.21,1.21,0,0,1,8.03,18.679M22.1,3a1.235,1.235,0,0,0-.856.35L10.442,14.156l3.317,3.317L24.565,6.666a1.2,1.2,0,0,0,0-1.7L22.949,3.35A1.177,1.177,0,0,0,22.1,3ZM8.03,16.267a3.613,3.613,0,0,0-3.618,3.618A2.447,2.447,0,0,1,2,22.3a6.24,6.24,0,0,0,4.824,2.412,4.823,4.823,0,0,0,4.824-4.824A3.613,3.613,0,0,0,8.03,16.267Z",
    transform: "translate(0.412 0.618)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushIconBlack);
export default __webpack_public_path__ + "static/media/brushIcon_black.c380ae0505a756ba6a5c7f82fe6ba213.svg";
export { ForwardRef as ReactComponent };